// Base styles first, so hero and section rules override them in the cascade.
import "./HomeRound5.css";
import "./blue2/base.css";
import type { ReactNode } from "react";
import { useSearchParams } from "react-router";
import { useFonts } from "./blue2/bits";
import { EventTicket, WhereIllBe } from "./blue2/SectionsB";
import { PALETTES, paletteStyle } from "./pattern2/palettes";
import { EventMarquee } from "./blue2/events/Marquee";
import { EventPatch } from "./blue2/events/Patch";
import { EventGigPoster } from "./blue2/events/GigPoster";
import { EventPatternEnvelope } from "./blue2/events/PatternEnvelope";
import { EventCandle } from "./blue2/events/Candle";

/* Design page: alternatives to blue-2's event ticket, each shown in the real
   "come say hi!" section with the Team mix colors, for team review.
   ?only=<key> shows one. */

const VARIANTS: { key: string; label: string; el: ReactNode }[] = [
  { key: "current", label: "First ticket (replaced by E)", el: <EventTicket /> },
  { key: "marquee", label: "A · Theater marquee", el: <EventMarquee /> },
  { key: "patch", label: "B · Embroidered patch", el: <EventPatch /> },
  { key: "poster", label: "C · Gig poster", el: <EventGigPoster /> },
  { key: "envelope", label: "D · Pattern envelope", el: <EventPatternEnvelope /> },
  { key: "candle", label: "E · Candlelit card (in use)", el: <EventCandle /> },
];

export function EventCardLab() {
  useFonts();
  const [params] = useSearchParams();
  const only = params.get("only");
  const where = PALETTES.find(p => p.key === "secondaries")!;
  return <div className="h5 b2" style={paletteStyle(PALETTES[0])}>
    {VARIANTS.filter(v => !only || v.key === only).map(v => <div key={v.key} data-variant={v.key}>
      <p style={{ margin: 0, padding: "14px 5vw", background: "#1b1b1b", color: "#fff", font: "700 13px Figtree, sans-serif", letterSpacing: ".12em", textTransform: "uppercase" }}>{v.label}</p>
      <div style={{ display: "contents", ...paletteStyle(where) }}><WhereIllBe event={v.el} /></div>
    </div>)}
  </div>;
}
